import React from 'react';
import { useI18n } from '../i18n/i18nService'; // Assurez-vous que i18n est correctement configuré
import DataTable from '../components/common/DataTable';


const Dashboard = () => {
  const { t } = useI18n();

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">{t('dashboard')}</h1>
      <p>{t('welcome_to_dashboard')}</p>
      {/* Ajoutez ici le contenu spécifique du tableau de bord */}
      <DataTable />
    </div>
  );
};

export default Dashboard;